import React from 'react';
import { Wrench, Clock } from 'lucide-react';

/**
 * Full-page takeover shown to non-admin users when maintenance mode is ON.
 */
export function MaintenancePage({ message, eta }) {
  const etaStr = eta ? new Date(eta).toLocaleString('en-PH', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  }) : null;

  return (
    <div className="min-h-screen bg-[#000B18] text-white flex items-center justify-center px-4 py-10"
      data-testid="maintenance-takeover">
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-[#00E5FF]/20 to-[#00E676]/20 flex items-center justify-center border border-[#00E5FF]/30">
          <Wrench className="w-10 h-10 text-[#00E5FF]" />
        </div>
        <h1 className="font-outfit text-3xl sm:text-4xl font-bold mb-3">
          We&apos;ll be back soon
        </h1>
        <p className="text-[#A0B4CC] text-base sm:text-lg leading-relaxed mb-6">
          {message || 'We\'re making things better. We\'ll be back shortly.'}
        </p>
        {etaStr && (
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#041A3B] border border-white/10 text-sm text-[#A0B4CC]">
            <Clock className="w-4 h-4 text-[#00E676]" />
            Estimated back online: <span className="text-white font-medium">{etaStr}</span>
          </div>
        )}
        <div className="mt-10 text-xs text-[#5C7599]">
          All Global Access · Maintenance in progress
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;
